import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { addSuggest, getContactUs } from "../../services/info/info";
import PhoneIcon from "@mui/icons-material/Phone";
import { Link } from "react-router-dom";
import RoomIcon from "@mui/icons-material/Room";
import LanguageIcon from "@mui/icons-material/Language";
import toast from "react-hot-toast"; // Import the toast library
import { useTranslation } from "react-i18next";

function AboutUs() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [contactInfo, setContactInfo] = useState([]);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const { t } = useTranslation();
  // Fetch the contact info when the component mounts
  const handleInfo = async () => {
    try {
      const response = await getContactUs();
      setContactInfo(response.data);
    } catch (err) {
      console.error("Error fetching contact info:", err);
    }
  };

  useEffect(() => {
    handleInfo();
  }, []);

  // Form submission handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      title,
      description,
    };

    try {
      // Send suggestion data
      await addSuggest(data);

      // Show success toast
      toast.success(t("Toast.success"));

      // Clear the inputs after successful submission
      setTitle("");
      setDescription("");
      setError(null);
    } catch (err) {
      setSuccess(false);
      setError(t("Toast.error"));

      // Show error toast
      toast.error(t("Toast.error"));
    }
  };

  return (
    <Box
      sx={{
        justifyContent: "start",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          justifyContent: "start",
          alignItems: "start",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          width: "100%",
          margin: "2rem 0",
        }}
      >
        <Box
          sx={{
            justifyContent: "start",
            alignItems: "center",
            display: "flex",
            gap: "1rem",
            backgroundColor: "#F4F2FB",
            width: "100%",
            borderRadius: "15px",
            p: "12px",
          }}
        >
          <PhoneIcon fontSize="medium" color="primary" />
          <Link to={`tel:${contactInfo.phone}`}>
            <Typography
              variant="h4"
              sx={{ lineHeight: "1.6", wordSpacing: "1.5px" }}
            >
              {contactInfo.phone}
            </Typography>
          </Link>
        </Box>
        <Box
          sx={{
            justifyContent: "start",
            alignItems: "center",
            display: "flex",
            gap: "1rem",
            color: "#3b3b3b",
            backgroundColor: "#F4F2FB",
            width: "100%",
            borderRadius: "15px",
            p: "12px",
          }}
        >
          <RoomIcon fontSize="medium" color="primary" />
          <Typography
            sx={{ lineHeight: "1.6", fontSize: "14px", wordSpacing: "1.5px" }}
          >
            {contactInfo.addres}
          </Typography>
        </Box>
        <Box
          sx={{
            justifyContent: "start",
            alignItems: "center",
            display: "flex",
            gap: "1rem",
            color: "#3b3b3b",
            backgroundColor: "#F4F2FB",
            width: "100%",
            borderRadius: "15px",
            p: "12px",
          }}
        >
          <LanguageIcon fontSize="medium" color="primary" />
          <Typography variant="h4" className="underline">
            <Link to={contactInfo.website} target="_blank">
              {contactInfo.website}
            </Link>
          </Typography>
        </Box>
      </Box>

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          backgroundColor: "#F4F2FB",
          padding: ".8rem",
          borderRadius: "10px",
          color: "black",
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <TextField
          required
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          id="outlined-basic"
          label={t("About.title")}
          variant="outlined"
          fullWidth
          sx={{ marginBottom: "1.75rem" }}
        />
        <TextField
          required
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          id="outlined-multiline-static"
          label={t("About.desc")}
          multiline
          rows={4}
          placeholder={t("About.placeholder")}
          sx={{ marginBottom: "1.75rem" }}
        />
        <Button
          type="submit"
          variant="contained"
          color="secondary"
          sx={{
            width: "100%",
            borderRadius: "100px",
            marginBottom: "2rem",
            padding: "12px",
            fontSize: "16px",
          }}
          size="large"
        >
          {t("About.Send")}
        </Button>
      </Box>
    </Box>
  );
}

export default AboutUs;
